import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type LeadCreationRows = {
  label: string;
  id: vp.CreateLeadId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};

type InsideSalesLeadCreationRows = {
  label: vp.CreateInsideSalesLeadLabel;
  id: vp.CreateInsideSalesLeadId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};

type ISOLeadCreationRows = {
  label: vp.CreateISOLeadLabel;
  id: vp.CreateISOLeadId;
  require: boolean;
  preset: keyof vp.TextFieldPresets | undefined;
};

export const useBuildLeadCreationRows = (): LeadCreationRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Leads.Create' });

  return [
    {
      label: t('firstName'),
      id: vp.CreateLeadId.FirstName,
      require: true,
      preset: 'text',
    },
    {
      label: t('lastName'),
      id: vp.CreateLeadId.LastName,
      require: true,
      preset: 'text',
    },
    {
      label: t('email'),
      id: vp.CreateLeadId.BusinessEmailAddress,
      require: true,
      preset: 'email',
    },
    {
      label: t('company'),
      id: vp.CreateLeadId.CompanyName,
      require: true,
      preset: 'text',
    },
    {
      label: t('dba'),
      id: vp.CreateLeadId.DoingBusinessAs,
      require: true,
      preset: 'text',
    },
    {
      label: t('website'),
      id: vp.CreateLeadId.WebsiteURL,
      require: false,
      preset: 'text',
    },
    {
      label: t('businessModel'),
      id: vp.CreateLeadId.BusinessModel,
      require: false,
      preset: 'text',
    },
    {
      label: t('comments'),
      id: vp.CreateLeadId.Comments,
      require: false,
      preset: 'text',
    },
  ];
};

export const buildInsideSalesPartnerLeadCreationRows = (): InsideSalesLeadCreationRows[] => [
  {
    label: vp.CreateInsideSalesLeadLabel.PartnerID,
    id: vp.CreateInsideSalesLeadId.PartnerID,
    require: true,
    preset: 'text',
  },
];

export const buildInsideSalesAgentLeadCreationRows = (): InsideSalesLeadCreationRows[] => [
  {
    label: vp.CreateInsideSalesLeadLabel.AgentID,
    id: vp.CreateInsideSalesLeadId.AgentID,
    require: true,
    preset: 'text',
  },
];

export const buildISOPartnerDataAggregatorLeadCreationRows = (): ISOLeadCreationRows[] => [
  {
    label: vp.CreateISOLeadLabel.DataAggregator,
    id: vp.CreateISOLeadId.DataAggregator,
    require: true,
    preset: 'text',
  },
];

export const buildISOSystemOfRecordLeadCreationRow = (): ISOLeadCreationRows[] => [
  {
    label: vp.CreateISOLeadLabel.SystemOfRecord,
    id: vp.CreateISOLeadId.SystemOfRecord,
    require: true,
    preset: 'text',
  },
];
